import ContentLoader from 'react-content-loader';
import styled from 'styled-components';

export const UserBalanceTableWrapper = styled.div``;

export const HeaderLoader = styled(ContentLoader)`
  height: 3.2rem;
  width: 100%;
  display: none;

  ${({ theme }) => theme.media.laptop`
    height: 4.7rem;
    display: block;
  `};
`;

export const HeaderLine = styled.rect`
  height: 0.1rem;
  width: 100%;

  y: 3.1rem;
  ${({ theme }) => theme.media.laptop`
    y: 4.6rem;
  `};
`;

export const Asset = styled.rect`
  width: 7rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;

  ${({ theme }) => theme.media.mobileL`
    x: 1.6rem;
  `};

  ${({ theme }) => theme.media.laptop`
    y: 1.35rem;
    x: 2.4rem;
  `};
`;

export const Amount = styled.rect`
  width: 10rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;
  x: 40%;
  ${({ theme }) => theme.media.laptop`
    y: 1.35rem;
    x: 53%;
  `};
`;
export const Change = styled.rect`
  display: none;

  width: 7rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;

  ${({ theme }) => theme.media.laptop`
    display:initial;
    y: 1.35rem;
    x: 75%;

    width: 14rem;
  `};
`;

export const Price = styled.rect`
  width: 7rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;

  x: calc(100% - 7rem);

  ${({ theme }) => theme.media.mobileL`
      x: 70%;
  `};

  ${({ theme }) => theme.media.laptop`
    y: 1.35rem;
    x: 20%;
  `};
`;

export const Balance = styled.rect`
  width: 9rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 0.6rem;

  x: calc(100% - 7rem);

  ${({ theme }) => theme.media.mobileL`
      x: 70%;
  `};

  ${({ theme }) => theme.media.laptop`
    y: 1.35rem;
    x: 37%;
  `};
`;

export const BodyLoaderWrapper = styled(ContentLoader)`
  height: 6.1rem;
  width: 100%;
`;

export const AssetIcon = styled.circle`
  cx: 2.4rem;
  cy: 3rem;

  r: 1.9rem;

  ${({ theme }) => theme.media.mobileL`
      cx: 3.5rem;
  `};
`;
export const AssetName = styled.rect`
  height: 1.8rem;
  width: 5rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 1.3rem;
  x: 5.3rem;

  ${({ theme }) => theme.media.tablet`
      height: 1.3rem;
      x: 6.4rem;
      y: 2rem;
      width: 7rem;
  `};
`;

export const AssetCode = styled.rect`
  height: 1.8rem;
  width: 3rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 3rem;
  x: 5.3rem;

  ${({ theme }) => theme.media.mobileL`
      x: 6.4rem;
  `};
`;

export const BodyPrice = styled.rect`
  height: 1.2rem;
  width: 12rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 3rem;
  x: 62%;

  ${({ theme }) => theme.media.laptop`
      y: 1.9rem;
      x: 20%;
      height: 1.8rem;
      width: 6rem;
  `};
`;

export const BodyBalance = styled.rect`
  height: 1.8rem;
  width: 9rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 1rem;
  x: 70%;

  ${({ theme }) => theme.media.laptop`
      height: 2rem;
      
      y: 1.8rem;
      x: 37%;
  `};
`;

export const BodyAmount = styled.rect`
  width: 6rem;
  height: 1.2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 4rem;
  x: 5.3rem;

  ${({ theme }) => theme.media.laptop`
    x: 53%;
    y: 1.8rem;
    height: 2rem;
    width: 11rem;
  `};
`;

export const BodyChangeInPercentage = styled.rect`
  display: none;
  width: 5rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 1rem;

  ${({ theme }) => theme.media.laptop`
    x: 75%;
    display: block;
  `};
`;

export const BodyChangeInUsd = styled.rect`
  display: none;

  width: 5rem;
  height: 2rem;

  rx: ${({ theme }) => theme.borderRadius.medium};
  ry: ${({ theme }) => theme.borderRadius.medium};

  y: 3.4rem;

  ${({ theme }) => theme.media.laptop`
    x: 75%;
    display: block;
  `};
`;
